import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { parse } from 'yaml'

import { useComponentProvider } from '@/components/ViewComponentModal/ViewComponentProvider'
import { useOrg } from '@/hooks'
import useValidateEndpoint from '@/hooks/useValidate'
import { ConfigDataScreen } from '@/screens/ComponentLibrary/components'
import { useGetCustomComponent } from '@/screens/ComponentLibrary/hooks'

import { SimpleApiConfig } from './Editor'

export const parseRecipeData = (
  orgSlug?: string | null,
  param?: { settings: SimpleApiConfig; name: string } | string | null
) => {
  if (!param || !orgSlug) return {}
  const parsedData: { settings: SimpleApiConfig; name: string } =
    typeof param === 'string' ? JSON.parse(param) : param

  return {
    data: parse(parsedData?.settings?.recipe || ''),
    organization: orgSlug,
    schemaName: 'SimpleApiCallConfig',
    schemaVersion: '1.0.0',
    version: '1.0.0',
  }
}

export const useParseRecipeData = (
  orgSlug?: string | null,
  param?: { settings: SimpleApiConfig; name: string } | string | null
) => {
  return useMemo(() => {
    return parseRecipeData(orgSlug, param)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(param), orgSlug])
}

export const ConfigData = () => {
  const { orgID } = useParams()
  const { componentID } = useComponentProvider()
  const org = useOrg(orgID)
  const current = useGetCustomComponent<SimpleApiConfig>(componentID)

  const config = useParseRecipeData(org.data?.slug, current.data)
  const valid = useValidateEndpoint(config, componentID)

  return (
    <ConfigDataScreen
      config={config}
      current={current}
      org={org}
      rootName="Simple api call"
      valid={valid}
    />
  )
}
